const API_BASE = import.meta.env.VITE_API_BASE_URL || "";
const KEY_NAME = "prosights-migrate-api-key";

export class ApiError extends Error {
  constructor(
    message: string,
    readonly status: number,
  ) {
    super(message);
  }
}

export function getApiKey() {
  return sessionStorage.getItem(KEY_NAME) || "";
}

export function setApiKey(value: string) {
  sessionStorage.setItem(KEY_NAME, value);
}

export function clearApiKey() {
  sessionStorage.removeItem(KEY_NAME);
}

export async function api<T>(
  path: string,
  init: RequestInit = {},
): Promise<T> {
  const response = await fetch(`${API_BASE}${path}`, {
    ...init,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getApiKey()}`,
      ...init.headers,
    },
  });
  if (!response.ok) {
    let message = `Request failed (${response.status})`;
    try {
      const payload = (await response.json()) as { detail?: string };
      message = payload.detail || message;
    } catch {
      // Keep the status-based fallback when a proxy returns non-JSON.
    }
    throw new ApiError(message, response.status);
  }
  if (response.status === 204) return undefined as T;
  return response.json() as Promise<T>;
}

export function streamUrl(path: string) {
  return `${API_BASE}${path}`;
}
